const template = `
  <notifier class="alert alert-danger" ng-if="$ctrl.active">
    <notifier-message>OFFLINE</notifier-message>
  </notifier>
`;

function controller($window, $scope) {
	const ctrl = this;

	ctrl.active = true;
	ctrl.$onInit = onInit;

	function onInit() {
		const _window = angular.element($window);
		_window.on("offline", () => {
			this.active = true;
			$scope.$evalAsync();
		});
		_window.on("online", () => {
			this.active = false;
			$scope.$evalAsync();
		});
	}
}

export default angular
	.module("vesl.componenet.online-notifier", [])
	.component("onlineNotifier", {
		template,
		controller
	}).name;
